import { RiskyDisclosureParagraph } from '@/components/common/DisclosureParagraph';
import { FlexCol } from '@/components/common/Flex';
import GoalDetailDisconnectedAccounts from '@/components/goals/detail/GoalDetailDisconnectedAccounts';
import { useAtomicStatus } from '@common/react/atomic';
import { getMyGoalAccount } from '@common/react/goals';
import { RetirementGoalDetailContainerInner } from '../retirement/RetirementGoalDetailContainer';
import GoalDetailAccountsSection from './GoalDetailAccountsSection';
import GoalDetailChart from './GoalDetailChart';
import { useGoalDetailContext } from './GoalDetailContext';
import GoalDetailHeader from './GoalDetailHeader';
import GoalDetailStatementSection from './GoalDetailStatementSection';
import GoalTitleSection from './GoalDetailTitleSection';
import GoalDetailTransfersSection from './GoalDetailTransfersSection';
import GoalOnboarding from './onboarding/GoalOnboarding';
import GoalOnboardingCelebration from './onboarding/GoalOnboardingCelebration';
import { GoalOnboardingProvider } from './onboarding/GoalOnboardingContext';

export default function GoalDetail() {
    const {
        position,
        setPosition,
        goal,
        goalUnfiltered,
        currentRateInfo,
        onClose,
    } = useGoalDetailContext();
    const atomicStatus = useAtomicStatus();

    if (position === 'ONBOARDING' && goalUnfiltered) {
        return (
            <GoalOnboardingProvider goalUnfiltered={goalUnfiltered}>
                <GoalOnboarding />
            </GoalOnboardingProvider>
        );
    }

    if (position === 'CELEBRATION' && goal) {
        return (
            <GoalOnboardingCelebration
                goal={goal}
                onComplete={() => {
                    const account = getMyGoalAccount(goal);
                    setPosition(account ? 'DETAILS' : 'ONBOARDING');
                }}
            />
        );
    }

    if (atomicStatus && goal?.type === 'RETIREMENT') {
        return (
            <RetirementGoalDetailContainerInner
                goal={goal}
                currentRateInfo={currentRateInfo}
                onClose={onClose}
                atomicStatus={atomicStatus}
            />
        );
    }

    return (
        <FlexCol pb={8}>
            <GoalDetailHeader />
            <GoalTitleSection />
            <GoalDetailChart />
            <GoalDetailDisconnectedAccounts />
            <GoalDetailTransfersSection />
            <GoalDetailStatementSection />
            <GoalDetailAccountsSection />
            <RiskyDisclosureParagraph px={16} mt={16} />
        </FlexCol>
    );
}
